import { AnyAction } from 'redux';
import {
    AppliedFundsFilters,
    AppliedHoldingsFilters,
    AppliedRecommendationsFilters,
    CHECK_SELECTED_HOLDING_SCHEMES,
    CLIENTCODE,
    RecommendationsActiveCategories,
    SelectedSchemesObj,
    SET_APPLIED_FUNDS_FILTERS,
    SET_APPLIED_HOLDINGS_FILTERS,
    SET_APPLIED_RECOMMENDATIONS_FILTERS,
    SET_EXPLORE_MUTUAL_FUNDS_PAGE_VISITED,
    SET_HOLDINGS_ACTIVE_CATEGORY,
    SET_RECOMMENDATIONS_ACTIVE_CATEGORIES,
    SET_SELECTED_HOLDINGS_INFO,
    SET_SELECTED_HOLDINGS_IDS,
    SET_SELECTED_SCHEMES,
    SET_ALL_SELECTED_HOLDINGS_INFO,
    AppliedSystematicPlansFilter,
    SET_SYSTEMATIC_PLANS_SEARCH_TEXT,
    SET_APPLIED_SYSTEMATIC_PLANS_FILTERS
} from '../types/investorProfile';
import { LOGOUT_SUCCESS } from '../types/auth';
import { HoldingsTableData } from '../../components/investorOverview/mutualFund/holdings/types';

export type InvestorProfileType = {
    appliedFundsFilters: AppliedFundsFilters[];
    selectedSchemesObj: SelectedSchemesObj;
    isExploreMutualFundsPageVisited: boolean;
    appliedRecommendationsFilters: AppliedRecommendationsFilters[];
    recommendationsActiveCategories: RecommendationsActiveCategories
    clientCode: string;
    appliedHoldingsFilters: AppliedHoldingsFilters[];
    holdingsActiveCategory: string;
    selectedHoldingsIds: string[];
    checkedHoldingInvestments: string[];
    selectedHoldingsInfo: Array<{ checkedId: string; schemeId: string; folioNo: string; uniqueId: string; }>;
    selectAllHoldingsInfo: HoldingsTableData[],
    systematicPlansSearchText: string;
    appliedSystematicPlansFilters: AppliedSystematicPlansFilter[];

};

const initState: Partial<InvestorProfileType> = {
    appliedFundsFilters: [],
    selectedSchemesObj: {},
    isExploreMutualFundsPageVisited: false,
    appliedRecommendationsFilters: [],
    recommendationsActiveCategories: {
        primaryCategory: "New Purchase",
        secondaryCategory: "Lumpsum"
    },
    clientCode: '',
    appliedHoldingsFilters: [],
    holdingsActiveCategory: "All",
    selectedHoldingsIds: [],
    checkedHoldingInvestments: [],
    selectedHoldingsInfo: [],
    selectAllHoldingsInfo: [],
    systematicPlansSearchText: "",
    appliedSystematicPlansFilters: []
};
export default function investorProfileReducer(state = initState, action: AnyAction): Partial<InvestorProfileType> {
    switch (action.type) {
        case SET_APPLIED_FUNDS_FILTERS: {
            return {
                ...state,
                appliedFundsFilters: action.appliedFundsFilters,
            };
        }
        case SET_SELECTED_SCHEMES: {
            return {
                ...state,
                selectedSchemesObj: action.selectedSchemesObj,
            };
        }
        case SET_APPLIED_RECOMMENDATIONS_FILTERS: {
            return {
                ...state,
                appliedRecommendationsFilters: action.appliedRecommendationsFilters,
            };
        }
        case SET_RECOMMENDATIONS_ACTIVE_CATEGORIES: {
            return {
                ...state,
                recommendationsActiveCategories: action.recommendationsActiveCategories
            }
        }
        case CLIENTCODE: {
            return {
                ...state,
                clientCode: action.clientCode
            }
        }
        case SET_EXPLORE_MUTUAL_FUNDS_PAGE_VISITED: {
            return {
                ...state,
                isExploreMutualFundsPageVisited: action.isExploreMutualFundsPageVisited
            }
        }
        case SET_APPLIED_HOLDINGS_FILTERS: {
            return {
                ...state,
                appliedHoldingsFilters: action.appliedHoldingsFilters
            }
        }
        case SET_HOLDINGS_ACTIVE_CATEGORY: {
            return {
                ...state,
                holdingsActiveCategory: action.holdingsActiveCategory
            }
        }
        case SET_SELECTED_HOLDINGS_IDS: {
            return {
                ...state,
                selectedHoldingsIds: action.selectedHoldingsIds
            }
        }
        case CHECK_SELECTED_HOLDING_SCHEMES: {
            return {
                ...state,
                checkedHoldingInvestments: action.checkedHoldingInvestments
            }
        }
        case SET_SELECTED_HOLDINGS_INFO: {
            // console.log("redfucer", action.selectedHoldingsInfo)
            return {
                ...state,
                selectedHoldingsInfo: action.selectedHoldingsInfo
            }
        }
        case SET_ALL_SELECTED_HOLDINGS_INFO: {
            return {
                ...state,
                selectAllHoldingsInfo: action.selectAllHoldingsInfo
            }
        }
        case SET_SYSTEMATIC_PLANS_SEARCH_TEXT: {
            return {
                ...state,
                systematicPlansSearchText: action.systematicPlansSearchText
            }
        }
        case SET_APPLIED_SYSTEMATIC_PLANS_FILTERS: {
            return {
                ...state,
                appliedSystematicPlansFilters: action.appliedSystematicPlansFilters
            }
        }
        case LOGOUT_SUCCESS: {
            return initState
        }
        default:
            return state;
    }
}